import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_all_missions } from '../../api/missionsAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdMusicNote, MdPersonAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_time_difference } from '../../utils/helper';
import { FaGlobe, FaGlobeAsia } from 'react-icons/fa';
import DataTable from '../../components/ui/DataTable'

export default function MissionsPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [missionsData, setMissionsData] = useState([])
  const [loading, setLoading] = useState(true)
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [tempUserData, setTempUserData] = useState({})
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchMissions()
  }, [])

  const fetchMissions = async () => {
    setLoading(true)
    const data = await fetch_all_missions()
    if (data?.status === 200) {
      setMissionsData(data.data)
    }
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Title",
      accessor: "title"
    },
    {
      header: "Date & Time",
      accessor: "start_datetime",
      modifier: (data, row) => `${tidy_date(row?.start_datetime)} - ${tidy_date(row?.end_datetime)}`
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data, row) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]




  return (
    <AdminLayout
      navSelected={"Missions"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Missions</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/missions/details?mission_id=new")
            }}
          >
            <MdAdd size={16} />
            New Mission
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {missionsData.map((missions, index) => {
            if (!JSON.stringify(missions).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3>{missions.title}</h3>
                  <h3 className='card-subtitle'>{missions?.start_datetime ? tidy_date(missions.start_datetime) : "TBA"} - {missions?.end_datetime ? tidy_date(missions.end_datetime) : "TBA"}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/missions/details?mission_id=" + missions.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
          <DataTable
            columns={table_columns}
            data={missionsData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button
                    className="hover:underline"
                    onClick={() => {
                      navigate("/admin/missions/details?mission_id=" + row.id)
                    }}
                  >
                    View
                  </button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
